// render layout: false で使用する
import Rails from 'rails-ujs'
Rails.start()
